import { render, staticRenderFns } from "./InvoiceRecurringReportTableCustomerSkeleton.vue?vue&type=template&id=3633cb06&"
import script from "./InvoiceRecurringReportTableCustomerSkeleton.vue?vue&type=script&lang=ts&"
export * from "./InvoiceRecurringReportTableCustomerSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3633cb06')) {
      api.createRecord('3633cb06', component.options)
    } else {
      api.reload('3633cb06', component.options)
    }
    module.hot.accept("./InvoiceRecurringReportTableCustomerSkeleton.vue?vue&type=template&id=3633cb06&", function () {
      api.rerender('3633cb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoice-recurring-report/components/InvoiceRecurringReportTableCustomerSkeleton.vue"
export default component.exports